import { render, staticRenderFns } from "./dotplot.vue?vue&type=template&id=fccc70aa&"
import script from "./dotplot.vue?vue&type=script&lang=js&"
export * from "./dotplot.vue?vue&type=script&lang=js&"
import style0 from "./dotplot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports